export default __webpack_public_path__ + "static/media/subham.9b997ac0.jpg";